import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import AuthLayout from "../layouts/auth-layout";
import Login from "../pages/login/login";
import AuthRoute from "../utils/AuthRoute";
import UpdatePassword from "../pages/update-password/update-password";
import ResetPassword from "../pages/reset-password/reset-password";

const GuestRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/login" />} />
      <Route
        path="/login"
        element={
          <AuthRoute>
            <AuthLayout>
              <Login />
            </AuthLayout>
          </AuthRoute>
        }
      />

      <Route
        path="/reset"
        element={
          <AuthRoute>
            <AuthLayout>
              <ResetPassword />
            </AuthLayout>
          </AuthRoute>
        }
      />

      <Route
        path="/password/reset/:token"
        element={
          <AuthRoute>
            <AuthLayout>
              <UpdatePassword />
            </AuthLayout>
          </AuthRoute>
        }
      />

      <Route
        path="/api/reset-password"
        element={
          <AuthRoute>
            <AuthLayout>
              <UpdatePassword isAdminInvite />
            </AuthLayout>
          </AuthRoute>
        }
      />
    </Routes>
  );
};

export default GuestRoutes;
